<template>
    <span>{{ language }}</span>
</template>

<script>
import { getValueWithKey } from '@utilities/functions';
import Cell from './cell';

export default {
    mixins: [ Cell ],

    computed: {
        language: function () {
            return getValueWithKey({key: this.value, optionList: this.options.mainLanguage})
        }
    }
}
</script>
